module.exports = __webpack_public_path__ + "img/dl5.e16d0e0e.png";